export const m8l1Solution = `use option::OptionTrait;
// do not modify code on this line or above

fn simple_option(optional_target: Option<felt252>) -> felt252 {
    if optional_target.is_some() == true {
        'option has some'
    } else {
        'option has none'
    }
}

// do not modify code on this line or below

#[test]
fn test_options() {
    let target = 'starklings';
    let optional_some = Option::Some(target);
    let optional_none: Option<felt252> = Option::None(());
    assert('option has some' == simple_option(optional_some), 'err1');
    assert('option has none' == simple_option(optional_none), 'err2');
}`;
